import React from 'react'

export default function ManageTemplate() {
  return (
    <div>
      <h1>Manage Template</h1>
    </div>
  )
}
